import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface ButtonStyledProps {
  pickListColumn?: boolean;
  editable?: boolean;
}

export const ButtonStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  alignSelf: { sm: 'center' },
})<ButtonStyledProps>`
  display: inline-flex;
  height: 20px;
  width: 20px;
  ${({ theme }) =>
    css`
      border-radius: ${theme.spacings[100]};
      background-color: ${theme.colors.primary[700]};
    `}
  ${({ editable }) =>
    editable
      ? css`
          cursor: pointer;
          pointer-events: default;
          opacity: 1;
        `
      : css`
          cursor: none;
          pointer-events: none;
          opacity: 0.4;
        `}
`;
